var ko = require('knockout');
var _ = require('underscore');

// A custom binding which appends a tooltip element after the given element. The
// text content of the tooltip comes from the element's title attribute, and the
// title attribute is removed.
//
// When the element is hovered, "visible" and "animating" classnames are added
// to the tooltip element. When the hover ends, the "visible" classname is
// removed immediately, and the "animating" classname is removed after a
// timeout (to aid with CSS animations).
//
// This binding doesn't require a viewModel in any way.
//
// Example:
//
//   tooltip: { text: 'My tooltip' }
//   tooltip: { text: function() { isMine() ? 'My tooltip' : 'Your tooltip' } }
//
var animatingDelay = 200;

module.exports = {
  init: function(element) {
    var $element = $(element);
    var animatingTimeout;
    var $tooltip = $('<span>').addClass('tooltip');

    ko.utils.domData.set(element, 'tooltip', $tooltip);

    $element.after($tooltip);
    $element.hover(function(e) {
      clearTimeout(animatingTimeout);
      $tooltip.addClass('animating');
      $tooltip.addClass('visible');
    }, function(e) {
      $tooltip.removeClass('visible');
      animatingTimeout = setTimeout(function() {
        $tooltip.removeClass('animating');
      }, animatingDelay);
    });
  },

  update: function(element, data) {
    var text = _.result(data(), 'text');
    var $tooltip = ko.utils.domData.get(element, 'tooltip');

    $tooltip.text(text);
  }
};
